import script from "./AdminEbayCategories.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminEbayCategories.vue?vue&type=script&setup=true&lang=js"

import "./AdminEbayCategories.vue?vue&type=style&index=0&id=0524947b&lang=scss&scoped=true"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0524947b"]])

export default __exports__